/* unplugin-vue-components disabled */import __unplugin_components_2 from 'D:/workspace/space-time-web/src/components/DictTag/index.vue';
import __unplugin_components_1 from 'D:/workspace/space-time-web/src/components/Pagination/index.vue';
import __unplugin_components_0 from 'D:/workspace/space-time-web/src/components/RightToolbar/index.vue';
import { unref as _unref, resolveComponent as _resolveComponent, isRef as _isRef, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, resolveDirective as _resolveDirective, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = {
  class: "page"
};
const _hoisted_2 = {
  class: "ele-wrapper-bgCard"
};
const _hoisted_3 = {
  class: "app-container"
};
const _hoisted_4 = {
  class: "head-container"
};
const _hoisted_5 = {
  class: "head-container"
};
const _hoisted_6 = ["onClick"];
const _hoisted_7 = {
  class: "dialog-footer"
};
const _hoisted_8 = {
  class: "el-upload__tip text-center"
};
const _hoisted_9 = {
  class: "el-upload__tip"
};
const _hoisted_10 = {
  class: "dialog-footer"
};
const _hoisted_11 = {
  style: {
    "height": "56rem"
  }
};
import { getToken } from "@/utils/auth";
import { treeselect } from "@/api/system/dept";
import { addUser, changeUserStatus, delUser, getUser, listUser, resetUserPwd, updateUser, getDeviceList } from "@/api/system/user";
import { forceLogoutByUserId, forceLogoutDevice } from "@/api/monitor/online";
import post from './selectPost';
export default {
  __name: 'index',
  setup(__props) {
    const router = useRouter();
    const {
      proxy
    } = getCurrentInstance();
    const {
      sys_normal_disable,
      sys_user_sex,
      device_type,
      device_status
    } = proxy.useDict("sys_normal_disable", "sys_user_sex", "device_type", "device_status");
    const loginDevice = ref(false);
    const loginDeviceList = ref([]);
    const userList = ref([]);
    const open = ref(false);
    const loading = ref(true);
    const showSearch = ref(true);
    const ids = ref([]);
    const single = ref(true);
    const multiple = ref(true);
    const total = ref(0);
    const title = ref("");
    const dateRange = ref([]);
    const deptName = ref("");
    const deptOptions = ref(undefined);
    const initPassword = ref(undefined);
    const postOptions = ref([]);
    const roleOptions = ref([]);
    const defaultSort = ref({
      prop: 'userType',
      order: 'descending'
    });
    /*** 用户导入参数 */
    const upload = reactive({
      // 是否显示弹出层（用户导入）
      open: false,
      // 弹出层标题（用户导入）
      title: "",
      // 是否禁用上传
      isUploading: false,
      // 是否更新已经存在的用户数据
      updateSupport: 0,
      // 设置上传的请求头部
      headers: {
        Authorization: "Bearer " + getToken()
      },
      // 上传的地址
      url: process.env.VUE_APP_BASE_API + "/system/user/importData"
    });
    // 列显隐信息
    const columns = ref([{
      key: 0,
      label: `用户编号`,
      visible: false
    }, {
      key: 1,
      label: `用户名称`,
      visible: true
    }, {
      key: 2,
      label: `用户昵称`,
      visible: true
    }, {
      key: 3,
      label: `部门`,
      visible: true
    }, {
      key: 4,
      label: `手机号码`,
      visible: true
    }, {
      key: 5,
      label: `在线状态`,
      visible: true
    }, {
      key: 7,
      label: `创建时间`,
      visible: true
    }]);
    const validatePass = (rule, value, callback) => {
      //必须包含⼤⼩写字母、数字、特殊字符长度再8-20位之间
      var regex = new RegExp("(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9]).{8,20}");
      if (value.length < 8 || value.length > 20) {
        callback(new Error("请输⼊8~20位密码"));
      } else if (!regex.test(value)) {
        callback(new Error("密码必须同时包含字母、数字和特殊字符其中三项且⾄少8位"));
      } else {
        callback();
      }
    };
    const data = reactive({
      form: {},
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        userName: undefined,
        phonenumber: undefined,
        status: undefined,
        deptId: undefined
      },
      queryDeviceParams: {
        pageNum: 1,
        pageSize: 10,
        name: undefined,
        deviceType: "",
        userId: undefined
      },
      rules: {
        userName: [{
          required: true,
          message: "用户名称不能为空",
          trigger: "blur"
        }, {
          min: 2,
          max: 20,
          message: "用户名称长度必须介于 2 和 20 之间",
          trigger: "blur"
        }],
        deptId: [{
          required: true,
          message: '归属部门不能为空',
          trigger: 'blur'
        }],
        nickName: [{
          required: true,
          message: "用户昵称不能为空",
          trigger: "blur"
        }],
        password: [{
          required: true,
          message: "用户密码不能为空",
          trigger: "blur"
        }, {
          required: true,
          validator: validatePass,
          trigger: "blur"
        }],
        email: [{
          type: "email",
          message: "请输入正确的邮箱地址",
          trigger: ["blur", "change"]
        }],
        phonenumber: [{
          pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
          message: "请输入正确的手机号码",
          trigger: "blur"
        }],
        roleIds: [{
          required: true,
          message: '请选择用户所属角色',
          trigger: 'blur'
        }]
      }
    });
    const {
      queryParams,
      form,
      rules,
      queryDeviceParams
    } = toRefs(data);

    /** 通过条件过滤节点  */
    const filterNode = (value, data) => {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    };
    /** 根据名称筛选部门树 */
    watch(deptName, val => {
      proxy.$refs["deptTreeRef"].filter(val);
    });

    /** 查询部门下拉树结构 */
    function getTreeselect() {
      treeselect().then(response => {
        deptOptions.value = response.data;
      });
    }
    ;

    /** 查询用户列表 */
    function getList() {
      loading.value = true;
      listUser(proxy.addDateRange(queryParams.value, dateRange.value)).then(res => {
        loading.value = false;
        userList.value = res.rows;
        total.value = res.total;
      });
    }
    ;

    /** 节点单击事件 */
    function handleNodeClick(data) {
      queryParams.value.deptId = data.id;
      handleQuery();
    }
    ;

    /** 搜索按钮操作 */
    function handleQuery() {
      queryParams.value.pageNum = 1;
      getList();
    }
    ;

    /** 重置按钮操作 */
    function resetQuery() {
      dateRange.value = [];
      proxy.resetForm("queryRef");
      proxy.$refs["usertableRef"].sort(defaultSort.value.prop, defaultSort.value.order);
      handleQuery();
    }
    ;

    /** 排序触发事件 */
    function handleSortChange(column, prop, order) {
      queryParams.value.orderByColumn = column.prop;
      queryParams.value.isAsc = column.order;
      getList();
    }

    /** 删除按钮操作 */
    function handleDelete(row) {
      const userIds = row.userId || ids.value;
      const names = proxy.getNames(userIds, userList.value, "userId", "nickName");
      proxy.$modal.confirm("是否确认删除用户名称为\"" + names + "\"的数据项？").then(function () {
        return delUser(userIds);
      }).then(() => {
        getList();
        proxy.$modal.msgSuccess("删除成功");
      }).catch(() => {});
    }
    ;

    /** 导出按钮操作 */
    function handleExport() {
      proxy.download("system/user/export", {
        ...queryParams.value
      }, `user_${new Date().getTime()}.xlsx`);
    }
    ;
    function handOnlineUsers(onlineUsers) {
      loginDevice.value = true;
      loginDeviceList.value = onlineUsers;
    }

    /** 用户在线状态修改  */
    function handleStatusChange(row) {
      if (row.userName === "admin") {
        row.userType = row.userType === "00" ? "01" : "00";
        return;
      }
      if (row.userType === "01") {
        row.userType = row.userType === "00" ? "01" : "00";
        return;
      }
      let text = "强制退出";
      proxy.$modal.confirm("确认要\"" + text + "\"\"" + row.userName + "\"用户吗?").then(function () {
        return forceLogoutByUserId(row.userId);
      }).then(() => {
        proxy.$modal.msgSuccess(text + "成功");
      }).catch(function () {
        row.userType = row.userType === "00" ? "01" : "00";
      });
    } /** 用户在线设备强制下线状态修改  */
    function handleDeviceStatusChange(row) {
      let text = "强制退出";
      proxy.$modal.confirm("确认要\"" + text + "" + row.userName + "的" + row.brower + "\"设备吗?").then(function () {
        return forceLogoutDevice(row.token);
      }).then(() => {
        proxy.$modal.msgSuccess(text + "成功");
      }).catch(function () {
        row.userType = row.userType === "00" ? "01" : "00";
      });
    }
    /*function handleStatusChange(row) {
      let text = row.status === "0" ? "启用" : "停用";
      proxy.$modal.confirm("确认要\"" + text + "\"\"" + row.userName + "\"用户吗?").then(function () {
        return changeUserStatus(row.userId, row.status);
      }).then(() => {
        proxy.$modal.msgSuccess(text + "成功");
      }).catch(function () {
        row.status = row.status === "0" ? "1" : "0";
      });
    };*/

    /** 更多操作 */
    function handleCommand(command, row) {
      switch (command) {
        case "handleResetPwd":
          handleResetPwd(row);
          break;
        case "handleAuthRole":
          handleAuthRole(row);
          break;
        default:
          break;
      }
    }
    ;

    /** 跳转角色分配 */
    function handleAuthRole(row) {
      const userId = row.userId;
      router.push("/system/user-auth/role/" + userId);
    }
    ;

    /** 重置密码按钮操作 */
    function handleResetPwd(row) {
      proxy.$prompt("请输入\"" + row.userName + "\"的新密码", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        closeOnClickModal: false,
        //校验方法
        inputValidator: value => {
          //必须包含⼤⼩写字母、数字、特殊字符长度再8-20位之间
          var regex = new RegExp("(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9]).{8,20}");
          var regex1 = new RegExp(/\s+/g);
          if (value.length < 8 || value.length > 20) {
            return "请输⼊8~20位密码";
          } else if (!regex.test(value)) {
            return "密码必须同时包含字母、数字和特殊字符其中三项且⾄少8位";
          } else if (regex1.test(value)) {
            return "密码不应该含有空格";
          } else {
            return;
          }
        },
        inputErrorMessage: "用户密码长度必须介于 8 和 20 之间"
      }).then(({
        value
      }) => {
        resetUserPwd(row.userId, value).then(response => {
          proxy.$modal.msgSuccess("修改成功，新密码是：" + value);
        });
      }).catch(() => {});
    }
    ;

    /** 选择条数  */
    function handleSelectionChange(selection) {
      ids.value = selection.map(item => item.userId);
      single.value = selection.length != 1;
      multiple.value = !selection.length;
    }
    ;

    /** 导入按钮操作 */
    function handleImport() {
      upload.title = "用户导入";
      upload.open = true;
    }
    ;

    /** 下载模板操作 */
    function importTemplate() {
      proxy.download("system/user/importTemplate", {}, `user_template_${new Date().getTime()}.xlsx`);
    }
    ;
    /**文件上传中处理 */
    const handleFileUploadProgress = (event, file, fileList) => {
      upload.isUploading = true;
    };
    /** 文件上传成功处理 */
    const handleFileSuccess = (response, file, fileList) => {
      upload.open = false;
      upload.isUploading = false;
      proxy.$refs["uploadRef"].handleRemove(file);
      proxy.$alert("<div style='overflow: auto;overflow-x: hidden;max-height: 70rem;padding: 1rem 2rem 0;'>" + response.msg + "</div>", "导入结果", {
        dangerouslyUseHTMLString: true
      });
      getList();
    };

    /** 提交上传文件 */
    function submitFileForm() {
      proxy.$refs["uploadRef"].submit();
    }
    ;

    /** 初始化部门数据 */
    function initTreeData() {
      // 判断部门的数据是否存在，存在不获取，不存在则获取
      if (deptOptions.value === undefined) {
        treeselect().then(response => {
          deptOptions.value = response.data;
        });
      }
    }
    ;

    /** 重置操作表单 */
    function reset() {
      form.value = {
        userId: undefined,
        deptId: undefined,
        userName: undefined,
        nickName: undefined,
        password: undefined,
        phonenumber: undefined,
        email: undefined,
        sex: undefined,
        status: "0",
        remark: undefined,
        postIds: [],
        roleIds: []
      };
      proxy.resetForm("userRef");
    }
    ;

    /** 取消按钮 */
    function cancel() {
      open.value = false;
      reset();
    }
    ;

    /** 新增按钮操作 */
    function handleAdd() {
      reset();
      initTreeData();
      getUser().then(response => {
        postOptions.value = response.posts;
        roleOptions.value = response.roles;
        open.value = true;
        title.value = "添加用户";
        form.value.password = initPassword.value;
      });
    }
    ;

    /** 修改按钮操作 */
    function handleUpdate(row) {
      reset();
      initTreeData();
      const userId = row.userId || ids.value;
      getUser(userId).then(response => {
        form.value = response.data;
        postOptions.value = response.posts;
        roleOptions.value = response.roles;
        form.value.postIds = response.postIds;
        form.value.roleIds = response.roleIds;
        open.value = true;
        title.value = "修改用户";
        form.password = "";
      });
    }
    ;

    /** 提交按钮 */
    function submitForm() {
      proxy.$refs["userRef"].validate(valid => {
        if (valid) {
          if (form.value.userId != undefined) {
            updateUser(form.value).then(response => {
              proxy.$modal.msgSuccess("修改成功");
              open.value = false;
              getList();
            });
          } else {
            addUser(form.value).then(response => {
              proxy.$modal.msgSuccess("新增成功");
              open.value = false;
              getList();
            });
          }
        }
      });
    }
    ;
    function getPostShow() {
      proxy.$refs["postRef"].show();
    }
    const visible = ref(false);
    const deviceList = ref([]);
    const deviceTotal = ref(0);
    function handleView(row) {
      queryDeviceParams.value.userId = row.userId;
      getDroneDeviceList();
      visible.value = true;
    }
    function handleDeviceQuery() {
      queryDeviceParams.value.pageNum = 1;
      getDroneDeviceList();
    }
    function getDroneDeviceList() {
      getDeviceList(queryDeviceParams.value).then(res => {
        deviceList.value = res.rows;
        deviceTotal.value = res.total;
      });
    }
    function resetDeviceQuery() {
      proxy.resetForm("queryDeviceRef");
      handleDeviceQuery();
    }
    function closeDialog() {
      queryDeviceParams.value.pageNum = 1;
      queryDeviceParams.value.userId = undefined;
      deviceList.value = [];
      deviceTotal.value = 0;
      visible.value = false;
    }
    getTreeselect();
    getList();
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_tree = _resolveComponent("el-tree");
      const _component_el_col = _resolveComponent("el-col");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_date_picker = _resolveComponent("el-date-picker");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_form = _resolveComponent("el-form");
      const _component_right_toolbar = __unplugin_components_0;
      const _component_el_row = _resolveComponent("el-row");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_switch = _resolveComponent("el-switch");
      const _component_el_tooltip = _resolveComponent("el-tooltip");
      const _component_el_table = _resolveComponent("el-table");
      const _component_pagination = __unplugin_components_1;
      const _component_el_dialog = _resolveComponent("el-dialog");
      const _component_el_tree_select = _resolveComponent("el-tree-select");
      const _component_el_radio = _resolveComponent("el-radio");
      const _component_el_radio_group = _resolveComponent("el-radio-group");
      const _component_upload_filled = _resolveComponent("upload-filled");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_checkbox = _resolveComponent("el-checkbox");
      const _component_el_link = _resolveComponent("el-link");
      const _component_el_upload = _resolveComponent("el-upload");
      const _component_dict_tag = __unplugin_components_2;
      const _directive_hasPermi = _resolveDirective("hasPermi");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_el_row, {
        gutter: 20
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 4,
          xs: 24
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_createVNode(_component_el_input, {
            modelValue: _unref(deptName),
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(deptName) ? deptName.value = $event : null),
            clearable: "",
            placeholder: "请输入部门名称",
            "prefix-icon": "Search",
            style: {
              "margin-bottom": "2rem"
            }
          }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_5, [_createVNode(_component_el_tree, {
            ref: "deptTreeRef",
            data: _unref(deptOptions),
            "expand-on-click-node": false,
            "filter-node-method": filterNode,
            props: {
              label: 'label',
              children: 'children'
            },
            "default-expand-all": "",
            "highlight-current": "",
            onNodeClick: handleNodeClick
          }, null, 8, ["data"])])]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 20,
          xs: 24
        }, {
          default: _withCtx(() => [_withDirectives(_createVNode(_component_el_form, {
            ref: "queryRef",
            inline: true,
            model: _unref(queryParams),
            "label-width": "8.6rem"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "用户名称",
              prop: "userName"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: _unref(queryParams).userName,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _unref(queryParams).userName = $event),
                clearable: "",
                placeholder: "请输入用户名称",
                style: {
                  "width": "18rem"
                },
                onKeyup: _withKeys(handleQuery, ["enter"])
              }, null, 8, ["modelValue"])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "手机号码",
              prop: "phonenumber"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: _unref(queryParams).phonenumber,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _unref(queryParams).phonenumber = $event),
                clearable: "",
                placeholder: "请输入手机号码",
                style: {
                  "width": "18rem"
                },
                onKeyup: _withKeys(handleQuery, ["enter"])
              }, null, 8, ["modelValue"])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "状态",
              prop: "status"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_select, {
                modelValue: _unref(queryParams).status,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _unref(queryParams).status = $event),
                clearable: "",
                placeholder: "用户状态",
                style: {
                  "width": "18rem"
                }
              }, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(sys_normal_disable), dict => {
                  return _openBlock(), _createBlock(_component_el_option, {
                    key: dict.value,
                    label: dict.label,
                    value: dict.value
                  }, null, 8, ["label", "value"]);
                }), 128))]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "创建时间",
              style: {
                "width": "30.8rem"
              }
            }, {
              default: _withCtx(() => [_createVNode(_component_el_date_picker, {
                modelValue: _unref(dateRange),
                "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => _isRef(dateRange) ? dateRange.value = $event : null),
                "end-placeholder": "结束日期",
                "range-separator": "-",
                "start-placeholder": "开始日期",
                type: "daterange",
                "value-format": "YYYY-MM-DD"
              }, null, 8, ["modelValue"])]),
              _: 1
            }), _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [_createVNode(_component_el_button, {
                icon: "Search",
                class: "satpro-button",
                onClick: handleQuery
              }, {
                default: _withCtx(() => [...(_cache[32] || (_cache[32] = [_createTextVNode("搜索", -1)]))]),
                _: 1
              }), _createVNode(_component_el_button, {
                icon: "Refresh",
                class: "satpro-button",
                onClick: resetQuery
              }, {
                default: _withCtx(() => [...(_cache[33] || (_cache[33] = [_createTextVNode("重置", -1)]))]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }, 8, ["model"]), [[_vShow, _unref(showSearch)]]), _createVNode(_component_el_row, {
            gutter: 10,
            class: "mb8"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 1.5
            }, {
              default: _withCtx(() => [_withDirectives((_openBlock(), _createBlock(_component_el_button, {
                icon: "Plus",
                plain: "",
                class: "satpro-button",
                onClick: handleAdd
              }, {
                default: _withCtx(() => [...(_cache[34] || (_cache[34] = [_createTextVNode("新增 ", -1)]))]),
                _: 1
              })), [[_directive_hasPermi, ['system:user:add']]])]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 1.5
            }, {
              default: _withCtx(() => [_withDirectives((_openBlock(), _createBlock(_component_el_button, {
                disabled: _unref(single),
                icon: "Edit",
                plain: "",
                class: "satpro-button",
                onClick: handleUpdate
              }, {
                default: _withCtx(() => [...(_cache[35] || (_cache[35] = [_createTextVNode("修改 ", -1)]))]),
                _: 1
              }, 8, ["disabled"])), [[_directive_hasPermi, ['system:user:edit']]])]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 1.5
            }, {
              default: _withCtx(() => [_withDirectives((_openBlock(), _createBlock(_component_el_button, {
                disabled: _unref(multiple),
                icon: "Delete",
                plain: "",
                class: "satpro-button",
                onClick: handleDelete
              }, {
                default: _withCtx(() => [...(_cache[36] || (_cache[36] = [_createTextVNode("删除 ", -1)]))]),
                _: 1
              }, 8, ["disabled"])), [[_directive_hasPermi, ['system:user:remove']]])]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 1.5
            }, {
              default: _withCtx(() => [_withDirectives((_openBlock(), _createBlock(_component_el_button, {
                icon: "Upload",
                plain: "",
                class: "satpro-button",
                onClick: handleImport
              }, {
                default: _withCtx(() => [...(_cache[37] || (_cache[37] = [_createTextVNode("导入 ", -1)]))]),
                _: 1
              })), [[_directive_hasPermi, ['system:user:import']]])]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 1.5
            }, {
              default: _withCtx(() => [_withDirectives((_openBlock(), _createBlock(_component_el_button, {
                icon: "Download",
                plain: "",
                class: "satpro-button",
                onClick: handleExport
              }, {
                default: _withCtx(() => [...(_cache[38] || (_cache[38] = [_createTextVNode("导出 ", -1)]))]),
                _: 1
              })), [[_directive_hasPermi, ['system:user:export']]])]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 1.5
            }, {
              default: _withCtx(() => [_withDirectives((_openBlock(), _createBlock(_component_el_button, {
                plain: "",
                class: "satpro-button",
                onClick: getPostShow
              }, {
                default: _withCtx(() => [...(_cache[39] || (_cache[39] = [_createTextVNode("岗位管理 ", -1)]))]),
                _: 1
              })), [[_directive_hasPermi, ['system:post:list']]])]),
              _: 1
            }), _createVNode(_component_right_toolbar, {
              showSearch: _unref(showSearch),
              "onUpdate:showSearch": _cache[5] || (_cache[5] = $event => _isRef(showSearch) ? showSearch.value = $event : null),
              columns: _unref(columns),
              onQueryTable: getList
            }, null, 8, ["showSearch", "columns"])]),
            _: 1
          }), _cache[40] || (_cache[40] = _createElementVNode("div", {
            class: "menu-name"
          }, [_createElementVNode("span", {
            class: "textinfo"
          }, "用户管理")], -1)), _withDirectives((_openBlock(), _createBlock(_component_el_table, {
            ref: "usertableRef",
            data: _unref(userList),
            "default-sort": _unref(defaultSort),
            onSelectionChange: handleSelectionChange,
            onSortChange: handleSortChange,
            "header-cell-style": {
              background: 'transparent !important',
              color: '#FFFFFF'
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_el_table_column, {
              align: "center",
              type: "selection",
              width: "50"
            }), _unref(columns)[0].visible ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: "userId",
              align: "center",
              label: "用户编号",
              prop: "userId"
            })) : _createCommentVNode("", true), _unref(columns)[1].visible ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: "userName",
              "show-overflow-tooltip": true,
              align: "center",
              label: "用户名称",
              prop: "userName",
              sortable: "custom",
              "sort-orders": ['descending', 'ascending']
            })) : _createCommentVNode("", true), _unref(columns)[2].visible ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: "nickName",
              "show-overflow-tooltip": true,
              align: "center",
              label: "用户昵称",
              prop: "nickName",
              sortable: "custom",
              "sort-orders": ['descending', 'ascending']
            })) : _createCommentVNode("", true), _unref(columns)[3].visible ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: "deptName",
              "show-overflow-tooltip": true,
              align: "center",
              label: "部门",
              prop: "dept.deptName"
            })) : _createCommentVNode("", true), _unref(columns)[4].visible ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: "phonenumber",
              align: "center",
              label: "手机号码",
              prop: "phonenumber",
              width: "124"
            })) : _createCommentVNode("", true), _unref(columns)[5].visible ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: "userType",
              prop: "userType",
              "show-overflow-tooltip": true,
              align: "center",
              label: "在线状态",
              sortable: "custom",
              "sort-orders": ['descending', 'ascending']
            }, {
              default: _withCtx(scope => [scope.row.onlineUsers.length <= 1 ? (_openBlock(), _createBlock(_component_el_switch, {
                key: 0,
                modelValue: scope.row.userType,
                "onUpdate:modelValue": $event => scope.row.userType = $event,
                "active-value": "01",
                "inactive-value": "00",
                onChange: $event => handleStatusChange(scope.row)
              }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])) : (_openBlock(), _createElementBlock("span", {
                key: 1,
                onClick: $event => handOnlineUsers(scope.row.onlineUsers)
              }, "在线数量：" + _toDisplayString(scope.row.onlineUsers.length), 9, _hoisted_6))]),
              _: 1
            })) : _createCommentVNode("", true), _unref(columns)[6].visible ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 6,
              align: "center",
              label: "创建时间",
              prop: "createTime",
              sortable: "custom",
              "sort-orders": ['descending', 'ascending'],
              width: "180"
            }, {
              default: _withCtx(scope => [_createElementVNode("span", null, _toDisplayString(_ctx.parseTime(scope.row.createTime)), 1)]),
              _: 1
            })) : _createCommentVNode("", true), _createVNode(_component_el_table_column, {
              align: "center",
              "class-name": "small-padding fixed-width",
              label: "操作",
              width: "180"
            }, {
              default: _withCtx(scope => [_createVNode(_component_el_tooltip, {
                content: "关联设备",
                placement: "top",
                "auto-close": 500
              }, {
                default: _withCtx(() => [_withDirectives(_createVNode(_component_el_button, {
                  icon: "Connection",
                  type: "primary",
                  link: "",
                  onClick: $event => handleView(scope.row)
                }, null, 8, ["onClick"]), [[_directive_hasPermi, ['drone:device:list']]])]),
                _: 2
              }, 1024), scope.row.userId !== 1 ? (_openBlock(), _createBlock(_component_el_tooltip, {
                key: 0,
                content: "修改",
                placement: "top",
                "auto-close": 500
              }, {
                default: _withCtx(() => [_withDirectives(_createVNode(_component_el_button, {
                  icon: "Edit",
                  type: "primary",
                  link: "",
                  onClick: $event => handleUpdate(scope.row)
                }, null, 8, ["onClick"]), [[_directive_hasPermi, ['system:user:edit']]])]),
                _: 2
              }, 1024)) : _createCommentVNode("", true), scope.row.userId !== 1 ? (_openBlock(), _createBlock(_component_el_tooltip, {
                key: 1,
                content: "删除",
                placement: "top",
                "auto-close": 500
              }, {
                default: _withCtx(() => [_withDirectives(_createVNode(_component_el_button, {
                  icon: "Delete",
                  type: "primary",
                  link: "",
                  onClick: $event => handleDelete(scope.row)
                }, null, 8, ["onClick"]), [[_directive_hasPermi, ['system:user:remove']]])]),
                _: 2
              }, 1024)) : _createCommentVNode("", true), scope.row.userId !== 1 ? (_openBlock(), _createBlock(_component_el_tooltip, {
                key: 2,
                content: "重置密码",
                placement: "top",
                "auto-close": 500
              }, {
                default: _withCtx(() => [_withDirectives(_createVNode(_component_el_button, {
                  icon: "Key",
                  type: "primary",
                  link: "",
                  onClick: $event => handleResetPwd(scope.row)
                }, null, 8, ["onClick"]), [[_directive_hasPermi, ['system:user:resetPwd']]])]),
                _: 2
              }, 1024)) : _createCommentVNode("", true)]),
              _: 1
            })]),
            _: 1
          }, 8, ["data", "default-sort"])), [[_directive_loading, _unref(loading)]]), _withDirectives(_createVNode(_component_pagination, {
            limit: _unref(queryParams).pageSize,
            "onUpdate:limit": _cache[6] || (_cache[6] = $event => _unref(queryParams).pageSize = $event),
            page: _unref(queryParams).pageNum,
            "onUpdate:page": _cache[7] || (_cache[7] = $event => _unref(queryParams).pageNum = $event),
            total: _unref(total),
            onPagination: getList
          }, null, 8, ["limit", "page", "total"]), [[_vShow, _unref(total) > 0]])]),
          _: 1
        })]),
        _: 1
      }), _unref(loginDevice) ? (_openBlock(), _createBlock(_component_el_dialog, {
        key: 0,
        modelValue: _unref(loginDevice),
        "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => _isRef(loginDevice) ? loginDevice.value = $event : null),
        title: '登录设备',
        "close-on-click-modal": false,
        "append-to-body": "",
        width: "100rem",
        draggable: ""
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table, {
          data: _unref(loginDeviceList),
          "header-cell-style": {
            background: 'transparent !important',
            color: '#FFFFFF'
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            key: "userName",
            align: "center",
            label: "用户名称",
            prop: "userName"
          }), _createVNode(_component_el_table_column, {
            key: "ipaddr",
            align: "center",
            label: "登录IP",
            prop: "ipaddr"
          }), _createVNode(_component_el_table_column, {
            key: "brower",
            align: "center",
            label: "登录设备",
            prop: "brower"
          }), _createVNode(_component_el_table_column, {
            align: "center",
            label: "登录时间"
          }, {
            default: _withCtx(scope => [_createElementVNode("span", null, _toDisplayString(_ctx.parseTime(scope.row.loginTime)), 1)]),
            _: 1
          }), _cache[42] || (_cache[42] = _createTextVNode("> ", -1)), _createVNode(_component_el_table_column, {
            align: "center",
            label: "强制下线",
            width: "120"
          }, {
            default: _withCtx(scope => [_createVNode(_component_el_button, {
              onClick: $event => handleDeviceStatusChange(scope.row)
            }, {
              default: _withCtx(() => [...(_cache[41] || (_cache[41] = [_createTextVNode("下线", -1)]))]),
              _: 1
            }, 8, ["onClick"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["data"])]),
        _: 1
      }, 8, ["modelValue"])) : _createCommentVNode("", true), _createVNode(_component_el_dialog, {
        modelValue: _unref(open),
        "onUpdate:modelValue": _cache[22] || (_cache[22] = $event => _isRef(open) ? open.value = $event : null),
        title: _unref(title),
        "close-on-click-modal": false,
        "append-to-body": "",
        width: "60rem",
        draggable: ""
      }, {
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_7, [_createVNode(_component_el_button, {
          type: "primary",
          onClick: submitForm
        }, {
          default: _withCtx(() => [...(_cache[43] || (_cache[43] = [_createTextVNode("确 定", -1)]))]),
          _: 1
        }), _createVNode(_component_el_button, {
          onClick: cancel
        }, {
          default: _withCtx(() => [...(_cache[44] || (_cache[44] = [_createTextVNode("取 消", -1)]))]),
          _: 1
        })])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          ref: "userRef",
          model: _unref(form),
          rules: _unref(rules),
          "label-width": "10rem"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "用户昵称",
                prop: "nickName"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: _unref(form).nickName,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => _unref(form).nickName = $event),
                  maxlength: "30",
                  placeholder: "请输入用户昵称"
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "归属部门",
                prop: "deptId"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_tree_select, {
                  modelValue: _unref(form).deptId,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => _unref(form).deptId = $event),
                  data: _unref(deptOptions),
                  props: {
                    value: 'id',
                    label: 'label',
                    children: 'children'
                  },
                  "check-strictly": "",
                  clearable: "",
                  placeholder: "请选择归属部门",
                  "value-key": "id"
                }, null, 8, ["modelValue", "data"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "手机号码",
                prop: "phonenumber"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: _unref(form).phonenumber,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => _unref(form).phonenumber = $event),
                  maxlength: "11",
                  placeholder: "请输入手机号码"
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "邮箱",
                prop: "email"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: _unref(form).email,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => _unref(form).email = $event),
                  maxlength: "50",
                  placeholder: "请输入邮箱"
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_unref(form).userId == undefined ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 0,
                label: "用户名称",
                prop: "userName"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: _unref(form).userName,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => _unref(form).userName = $event),
                  maxlength: "30",
                  placeholder: "请输入用户名称"
                }, null, 8, ["modelValue"])]),
                _: 1
              })) : _createCommentVNode("", true)]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_unref(form).userId == undefined ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 0,
                label: "用户密码",
                prop: "password"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: _unref(form).password,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => _unref(form).password = $event),
                  modelModifiers: {
                    trim: true
                  },
                  maxlength: "20",
                  placeholder: "请输入用户密码",
                  "show-password": "",
                  type: "password"
                }, null, 8, ["modelValue"])]),
                _: 1
              })) : _createCommentVNode("", true)]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "用户性别"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_select, {
                  modelValue: _unref(form).sex,
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => _unref(form).sex = $event),
                  placeholder: "请选择",
                  clearable: ""
                }, {
                  default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(sys_user_sex), dict => {
                    return _openBlock(), _createBlock(_component_el_option, {
                      key: dict.value,
                      label: dict.label,
                      value: dict.value
                    }, null, 8, ["label", "value"]);
                  }), 128))]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "状态"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_radio_group, {
                  modelValue: _unref(form).status,
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => _unref(form).status = $event)
                }, {
                  default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(sys_normal_disable), dict => {
                    return _openBlock(), _createBlock(_component_el_radio, {
                      key: dict.value,
                      label: dict.value
                    }, {
                      default: _withCtx(() => [_createTextVNode(_toDisplayString(dict.label), 1)]),
                      _: 2
                    }, 1032, ["label"]);
                  }), 128))]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "岗位"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_select, {
                  modelValue: _unref(form).postIds,
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => _unref(form).postIds = $event),
                  multiple: "",
                  "collapse-tags": "",
                  "collapse-tags-tooltip": "",
                  clearable: "",
                  placeholder: "请选择",
                  onChange: _cache[18] || (_cache[18] = $event => _ctx.$forceUpdate())
                }, {
                  default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(postOptions), item => {
                    return _openBlock(), _createBlock(_component_el_option, {
                      key: item.postId,
                      disabled: item.status == 1,
                      label: item.postName,
                      value: item.postId
                    }, null, 8, ["disabled", "label", "value"]);
                  }), 128))]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "角色",
                prop: "roleIds"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_select, {
                  modelValue: _unref(form).roleIds,
                  "onUpdate:modelValue": _cache[19] || (_cache[19] = $event => _unref(form).roleIds = $event),
                  multiple: "",
                  "collapse-tags": "",
                  "collapse-tags-tooltip": "",
                  clearable: "",
                  placeholder: "请选择",
                  onChange: _cache[20] || (_cache[20] = $event => _ctx.$forceUpdate())
                }, {
                  default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(roleOptions), item => {
                    return _openBlock(), _createBlock(_component_el_option, {
                      key: item.roleId,
                      disabled: item.status == 1,
                      label: item.roleName,
                      value: item.roleId
                    }, null, 8, ["disabled", "label", "value"]);
                  }), 128))]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "备注"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: _unref(form).remark,
                  "onUpdate:modelValue": _cache[21] || (_cache[21] = $event => _unref(form).remark = $event),
                  placeholder: "请输入内容",
                  type: "textarea"
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }, 8, ["model", "rules"])]),
        _: 1
      }, 8, ["modelValue", "title"]), _createVNode(_component_el_dialog, {
        modelValue: _unref(upload).open,
        "onUpdate:modelValue": _cache[25] || (_cache[25] = $event => _unref(upload).open = $event),
        title: _unref(upload).title,
        "close-on-click-modal": false,
        "append-to-body": "",
        width: "40rem",
        draggable: ""
      }, {
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_10, [_createVNode(_component_el_button, {
          type: "primary",
          onClick: submitFileForm
        }, {
          default: _withCtx(() => [...(_cache[49] || (_cache[49] = [_createTextVNode("确 定", -1)]))]),
          _: 1
        }), _createVNode(_component_el_button, {
          onClick: _cache[24] || (_cache[24] = $event => _unref(upload).open = false)
        }, {
          default: _withCtx(() => [...(_cache[50] || (_cache[50] = [_createTextVNode("取 消", -1)]))]),
          _: 1
        })])]),
        default: _withCtx(() => [_createVNode(_component_el_upload, {
          ref: "uploadRef",
          action: _unref(upload).url + '?updateSupport=' + _unref(upload).updateSupport,
          "auto-upload": false,
          disabled: _unref(upload).isUploading,
          headers: _unref(upload).headers,
          limit: 1,
          "on-progress": handleFileUploadProgress,
          "on-success": handleFileSuccess,
          accept: ".xlsx, .xls",
          drag: ""
        }, {
          tip: _withCtx(() => [_createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createVNode(_component_el_checkbox, {
            modelValue: _unref(upload).updateSupport,
            "onUpdate:modelValue": _cache[23] || (_cache[23] = $event => _unref(upload).updateSupport = $event)
          }, null, 8, ["modelValue"]), _cache[45] || (_cache[45] = _createTextVNode(" 是否更新已经存在的用户数据 ", -1))]), _cache[47] || (_cache[47] = _createElementVNode("span", null, "仅允许导入xls、xlsx格式文件。", -1)), _createVNode(_component_el_link, {
            underline: false,
            style: {
              "font-size": "1.2rem",
              "vertical-align": "baseline"
            },
            type: "primary",
            onClick: importTemplate
          }, {
            default: _withCtx(() => [...(_cache[46] || (_cache[46] = [_createTextVNode("下载模板 ", -1)]))]),
            _: 1
          })])]),
          default: _withCtx(() => [_createVNode(_component_el_icon, {
            class: "el-icon--upload"
          }, {
            default: _withCtx(() => [_createVNode(_component_upload_filled)]),
            _: 1
          }), _cache[48] || (_cache[48] = _createElementVNode("div", {
            class: "el-upload__text"
          }, [_createTextVNode("将文件拖到此处，或"), _createElementVNode("em", null, "点击上传")], -1))]),
          _: 1
        }, 8, ["action", "disabled", "headers"])]),
        _: 1
      }, 8, ["modelValue", "title"]), _createVNode(_unref(post), {
        ref: "postRef"
      }, null, 512), _createVNode(_component_el_dialog, {
        title: "关联设备",
        modelValue: _unref(visible),
        "onUpdate:modelValue": _cache[30] || (_cache[30] = $event => _isRef(visible) ? visible.value = $event : null),
        width: "120rem",
        "close-on-click-modal": false,
        "append-to-body": "",
        onBeforeClose: _cache[31] || (_cache[31] = $event => closeDialog()),
        draggable: ""
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form, {
          model: _unref(queryDeviceParams),
          ref: "queryDeviceRef",
          inline: true
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "设备类型",
            prop: "deviceType"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: _unref(queryDeviceParams).deviceType,
              "onUpdate:modelValue": _cache[26] || (_cache[26] = $event => _unref(queryDeviceParams).deviceType = $event),
              clearable: "",
              placeholder: "设备类型",
              style: {
                "width": "14rem"
              },
              onChange: handleDeviceQuery
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(device_type), dict => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: dict.value,
                  label: dict.label,
                  value: dict.value
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "名称",
            prop: "name"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: _unref(queryDeviceParams).name,
              "onUpdate:modelValue": _cache[27] || (_cache[27] = $event => _unref(queryDeviceParams).name = $event),
              clearable: "",
              placeholder: "请输入名称",
              style: {
                "width": "14rem"
              },
              onKeyup: _withKeys(handleDeviceQuery, ["enter"])
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [_createVNode(_component_el_button, {
              class: "satpro-button",
              icon: "Search",
              onClick: handleDeviceQuery
            }, {
              default: _withCtx(() => [...(_cache[51] || (_cache[51] = [_createTextVNode("搜索", -1)]))]),
              _: 1
            }), _createVNode(_component_el_button, {
              class: "satpro-button",
              icon: "Refresh",
              onClick: resetDeviceQuery
            }, {
              default: _withCtx(() => [...(_cache[52] || (_cache[52] = [_createTextVNode("重置", -1)]))]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"]), _createElementVNode("div", _hoisted_11, [_createVNode(_component_el_table, {
          data: _unref(deviceList),
          class: "device-table",
          "header-cell-style": {
            background: 'transparent !important',
            color: '#FFFFFF'
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            label: "设备编号",
            align: "center",
            prop: "id"
          }), _createVNode(_component_el_table_column, {
            label: "设备名称",
            align: "center",
            prop: "name",
            "show-overflow-tooltip": true
          }), _createVNode(_component_el_table_column, {
            label: "型号",
            align: "center",
            prop: "model",
            "show-overflow-tooltip": true
          }), _createVNode(_component_el_table_column, {
            label: "部门",
            align: "center",
            prop: "deptName",
            "show-overflow-tooltip": true
          }), _createVNode(_component_el_table_column, {
            label: "设备状态",
            align: "center",
            prop: "status"
          }, {
            default: _withCtx(scope => [_createVNode(_component_dict_tag, {
              options: _unref(device_status),
              value: scope.row.status
            }, null, 8, ["options", "value"])]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            key: "ownerUserName",
            "show-overflow-tooltip": true,
            align: "center",
            label: "设备负责人",
            prop: "ownerUserName"
          }), _createVNode(_component_el_table_column, {
            key: "phoneNumber",
            "show-overflow-tooltip": true,
            align: "center",
            label: "联系方式",
            prop: "phoneNumber"
          })]),
          _: 1
        }, 8, ["data"]), _withDirectives(_createVNode(_component_pagination, {
          class: "device-pagination-container",
          total: _unref(deviceTotal),
          page: _unref(queryDeviceParams).pageNum,
          "onUpdate:page": _cache[28] || (_cache[28] = $event => _unref(queryDeviceParams).pageNum = $event),
          limit: _unref(queryDeviceParams).pageSize,
          "onUpdate:limit": _cache[29] || (_cache[29] = $event => _unref(queryDeviceParams).pageSize = $event),
          onPagination: getDroneDeviceList
        }, null, 8, ["total", "page", "limit"]), [[_vShow, _unref(deviceTotal) > 0]])])]),
        _: 1
      }, 8, ["modelValue"])])])]);
    };
  }
};